/* eslint-disable no-param-reassign */
import axios from 'axios';
import { captchaInterceptor } from '@piplapps/pipl-ui';

import AppConfig from 'Config/AppConfig';
import { getCookie } from './CookiesService';

/**
 * Parses a param object to url query params
 * @param  {} params
 */
export function parseParams(params) {
  const keys = Object.keys(params);
  let options = '';

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === 'object';
    const isParamTypeArray = isParamTypeObject && params[key] && params[key].length >= 0;

    if (!isParamTypeObject) {
      options += `${key}=${encodeURIComponent(params[key])}&`;
    }

    if (isParamTypeObject && isParamTypeArray) {
      params[key].forEach((element) => {
        options += `${key}=${encodeURIComponent(element)}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
}

const TIMEOUT = process.env.NODE_ENV === 'development' ? 120000 : 50000;
const isIE =
  navigator.appName === 'Microsoft Internet Explorer' ||
  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv 11/));

function createClient({ baseURL, timeout = TIMEOUT }) {
  const axiosClient = axios.create({ baseURL, timeout });

  axiosClient.interceptors.request.use((config) => {
    config.headers['X-REQUESTED-WITH'] = 'XMLHttpRequest';
    config.paramsSerializer = parseParams;

    if (config.method !== 'get') {
      const csrfToken = getCookie(AppConfig.CSRF_COOKIE_NAME);

      if (csrfToken) {
        config.headers['X-CSRFTOKEN'] = csrfToken;
      }
    }

    if (config.method !== 'post' && isIE) {
      config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      config.params = {
        ...config.params,
        _: Date.now().toString(),
      };
    }

    return config;
  });
  const captchaUrl = `${AppConfig.APP_URI_PREFIX}captcha`;
  axiosClient.interceptors.response.use((request) => request, captchaInterceptor(captchaUrl));

  function sendRequest({ method, url, data = {}, params = {}, ...rest }) {
    const source = axios.CancelToken.source();

    const req = axiosClient({
      method,
      data,
      params,
      url,
      cancelToken: source.token,
      ...rest,
    });

    req.cancel = () => source.cancel();

    return req;
  }

  return {
    sendRequest,
  };
}

export default createClient;
